var map = {
	"./double-arrow.svg": "828b",
	"./expanding-blue.svg": "d4ed",
	"./expanding-green.svg": "543e",
	"./expanding-orange.svg": "cc98",
	"./per-minute.svg": "4d48",
	"./per-ride.svg": "48c5",
	"./total.svg": "2967"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "197c";